module.exports = __webpack_public_path__ + "static/img/enabled_gisaid_white.13fb9223.png";